<template id="notification">
  <div class="alert alert-danger" role="alert" transition="fade">
    <button
      @click="triggerClose(notification)"
      class="close"
      data-dismiss="alert" aria-label="Close"
      type="button"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <h5 v-if="notification.title">{{ notification.title }}</h5>
    <p style="white-space: break-spaces">
      {{ notification.text }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Notification",
  props: ["notification"],
  data: function () {
    return { timer: null };
  },
  created () {
    let timeout = Object.prototype.hasOwnProperty.call(
      this.notification,
      "timeout"
    )
      ? this.notification.timeout
      : true;
    if (timeout) {
      let delay = this.notification.delay || 3000;
      this.timer = setTimeout(
        function () {
          this.triggerClose(this.notification);
        }.bind(this),
        delay
      );
    }
  },

  methods: {
    triggerClose: function (notification) {
      clearTimeout(this.timer);
      this.$store.commit("removeNotification", notification);
    },
  },
};
</script>